import * as React from "react";

function SvgEmptyCircleIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={16}
      height={16}
      {...props}
    >
      <defs>
        <path
          d="M3.48 3.48A6.347 6.347 0 001.6 8c0 1.71.67 3.31 1.88 4.52A6.347 6.347 0 008 14.4c1.71 0 3.31-.67 4.52-1.88A6.347 6.347 0 0014.4 8c0-1.71-.67-3.31-1.88-4.52A6.347 6.347 0 008 1.6c-1.71 0-3.31.67-4.52 1.88M2.34 13.66A7.966 7.966 0 010 8c0-2.14.83-4.15 2.34-5.66A7.949 7.949 0 018 0c2.13 0 4.15.83 5.66 2.34A7.949 7.949 0 0116 8c0 2.13-.83 4.15-2.34 5.66A7.966 7.966 0 018 16c-2.14 0-4.15-.83-5.66-2.34"
          id="empty-circle-icon_svg__a"
        />
      </defs>
      <use xlinkHref="#empty-circle-icon_svg__a" fill="#dedede" />
      <use
        xlinkHref="#empty-circle-icon_svg__a"
        fillOpacity={0}
        stroke="#000"
        strokeOpacity={0}
      />
    </svg>
  );
}

export default SvgEmptyCircleIcon;
